import React, { useEffect, useState } from 'react'
import Sidebar from '../components/sidebar';
import Topbar from '../components/topbar';
import Button from 'react-bootstrap/Button';
import { Modal} from 'react-bootstrap';
import Pagination from "../components/Pagination";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function UserLogs() {
    const [totalPage, setTotalPage] = useState(1)
    const [currentPage, setCurrentPage] = useState(1)
    const [ListUserLogs, setListUserLogs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showError, setShowError] = useState(false);
    const [errMsg, setErrMsg] = useState("");

    const convertToDate=(resultDate)=>{
        const yyyy = resultDate.getFullYear();
        let mm = resultDate.getMonth(); // Months start at 0!
        let dd = resultDate.getDate();
        mm=mm+1;
        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;
        return yyyy+'-'+mm+'-'+dd+'T00:00:00.000Z';
    }

    let defaultBgDate = new Date()
    defaultBgDate.setDate(defaultBgDate.getDate() - 7)
    let defaultEndDate = new Date();
    defaultEndDate.setDate(defaultEndDate.getDate() +1)
    //console.log("---------------"+defaultBgDate)

    const [beginDate,setBeginDate]=useState(defaultBgDate);
    const [endDate,setEndateDate]=useState(defaultEndDate);
    const [email,setEmail]=useState("");
    
    const axiosInstance = axios.create({
      withCredentials: true,
    })

    let header =
    {
      'Content-Type': 'application/json'
    };
    const navigate = useNavigate();
    const bUrl = process.env.REACT_APP_B_URL;
    const getUserLogs = async (bgDate,edDate,email) => {
        setBeginDate(new Date(bgDate));
        setEndateDate(new Date(edDate));
        setEmail(email);
        let bgDateConvert=convertToDate(new Date(bgDate));
        let endDateConvert=convertToDate(new Date(edDate));
        let ulr = "/userLogs/findWithUser?page=" + currentPage + "&limit=10&beginDate="+bgDateConvert+"&endDate="+endDateConvert;
        if (email!= '') {
            ulr+="&email="+email;
        }
       
        const response = await axiosInstance.get(bUrl + ulr).catch((err) => {
          if (err?.response?.status == 401 || err?.response?.status == 403) {
            setErrMsg("Vous n'étes pas autorisé à faire cette opération!!")
            setShowError(true);
          }else{
            let msg=errMsg+ ' ' +err?.response?.status?(err?.response?.status):'';
            setErrMsg(msg);
            setShowError(true);
          }
          setIsLoading(false);
    
        });
        if (response) {
          if (response.status == 401) {
            navigate('/backoffice/login');
          }
         
          setListUserLogs(response.data.body);
          setTotalPage(response.data.totalPage);
          setCurrentPage(response.data.currentPage);
          setIsLoading(false);
          
        }
        
    }
   
    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
        return new Date(dateString).toLocaleDateString(undefined, options)
      }
    const handleCloseError = () => {
        setShowError(false);
      }
      useEffect(()=>{
        if (sessionStorage.getItem("name") === '' || sessionStorage.getItem("name") === null) {
          //console.log("----------GO GO GO ------------")
          navigate('/backoffice/login');
        }
        getUserLogs(beginDate, endDate, email);

      },[currentPage]);

    return (
        <div className="App">
      <div className="">

        <Sidebar />
        <section className="home">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="table-content mt-2 p-2 text d-flex justify-content-between">
                <div><p className='fw-bold'>Rapport d'audit des utilisateurs</p></div>
                <div><Topbar /></div>
              </div>
              <div className="table-content mt-3 p-3">
                <div className="d-flex justify-content-around">
                  <div className="form-group text">
                    <label htmlFor="exampleInputEmail1">Début</label>
                    <input type="Date" value={beginDate.toLocaleDateString('en-CA')} onChange={(e) => getUserLogs(e.target.value, endDate, email)} className="form-control" id="exampleInputEmail1"  />
                  </div>
                  <div className="form-group text">
                    <label htmlFor="phone">Fin</label>
                    <input type="Date" value={endDate.toLocaleDateString('en-CA')} onChange={(e) => getUserLogs(beginDate, e.target.value, email)} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone" />
                  </div>
                  <div className="form-group text">
                    <label htmlFor="email">Staff</label>
                    <input type="email" onChange={(e) => getUserLogs(beginDate, endDate, e.target.value)} className="form-control" id="email" aria-describedby="email" placeholder="email" />
                  </div>
                </div>
              </div>
              <div className="table-content mt-3 p-3">

                <div className="table-responsive-xl">
                  {isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :
                    <table className="table text">
                      <thead>
                        <tr>

                          <th scope="col">N°</th>
                          <th scope="col">Nom</th>
                          <th scope="col">Email</th>
                          <th scope="col">Login</th>
                          <th scope="col">Action</th>
                          <th scope="col">Reference</th>
                          <th scope="col">IP</th>
                          <th scope="col">Date</th>
                          <th></th>
                          <th></th>

                        </tr>
                      </thead>

                      <tbody>
                        {( ListUserLogs?.length > 0) ? ListUserLogs.map((a, i) => {
                          return <tr key={i}>
                            <td>{i}</td>
                            {a.staff!=null?
                            <>
                            <td>{a.staff.firstName+" "+a.staff.middleName +" "+a.staff.lastName}</td>
                            <td>{a.staff.email}</td>
                            <td>{a.staff.login}</td>
                            </>
                            :""}
                            <td>{a.userAction}</td>
                            <td>{a.code}</td>
                            <td>{a.iPaddress}</td>
                            
                            <td>{formatDate(a.createdDate)}</td>
                            
                            {/* <td><Link to={"/collections/"+a.hashids+"/byAgent/"}>Dépots</Link></td> */}

                          </tr>
                        }) : <tr></tr>}
                      </tbody>

                    </table>
                  }
                </div>
                <Pagination totalPage={totalPage} setCurrentPage={setCurrentPage} currentPage={currentPage} />
              </div>

            </div>
          </div>
        </section>
      </div>
      

      {/* =============================================error=============================== */}
      <Modal show={showError} onHide={handleCloseError} className="">
        <Modal.Header closeButton className="bg-danger">
          <Modal.Title>ERROR</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className='text-danger' style={{ textAlign: 'center' }}>{errMsg}</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseError}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
    )
}
